import { LabelWithExternalVendorIcons } from 'components/LabelWithExternalVendorIcons/LabelWithExternalVendorIcons'
import type { TPoint } from 'stores/fieldAssetStore/helperTypes'

const DEVICE_VENDOR_ICON_SIZE = 20

export const DashboardDeviceLabel = ({
  name,
  externalVendorNames,
}: {
  name: string
  externalVendorNames: TPoint['externalVendorNames']
}) => (
  <LabelWithExternalVendorIcons
    label={name}
    externalVendorNames={externalVendorNames}
    iconSize={DEVICE_VENDOR_ICON_SIZE}
  />
)
